<template>
  <v-container fluid>
    <SidebarNavigation />

    <v-card class="pa-1">
      <!-- 🔹 TOP BAR (Search + Action) -->
      <v-row class="pa-4">
        <v-col class="d-flex justify-end align-center">
          <!-- BUTTON -->
          <v-btn color="primary" class="mr-2" @click="openDialogCreate">
            <v-icon left>mdi-plus</v-icon>
            Tambah Data
          </v-btn>

          <!-- SEARCH -->
          <v-text-field
            v-model="pagination.search"
            label="Search"
            append-icon="mdi-magnify"
            dense
            hide-details
            outlined
            style="max-width: 250px"
            @input="debouncedSearch"
          />
        </v-col>
      </v-row>

      <!-- 🔹 TABLE -->
      <v-data-table
        mobile-breakpoint="0"
        fixed-header
        dense
        class="elevation-2 mx-4 mb-4"
        :headers="tableHeaders"
        :items="list"
        :items-per-page.sync="pagination.itemsPerPage"
        :page.sync="pagination.page"
        :sort-by="pagination.sortBy"
        :sort-desc="pagination.sortDesc"
        :server-items-length="total"
        item-key="id"
        @update:page="updateQuery('page', $event)"
        @update:items-per-page="updateQuery('itemsPerPage', $event)"
        @update:sort-by="updateQuery('sortBy', $event)"
        @update:sort-desc="updateQuery('sortDesc', $event)"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td class="text-center">{{ item.name || "-" }}</td>
              <td class="text-center">{{ item.account || "-" }}</td>
              <!-- <td class="text-center">{{ item.part || "-" }}</td> -->
              <td class="text-center">
                {{ `${item.kenaikan_harga}` || "-" }}
              </td>
              <td class="text-center">
                {{ `${item.part}` || "-" }}
              </td>
              <td class="text-center">
                <v-chip
                  small
                  :color="item.is_active == 1 ? 'green' : 'red'"
                  dark
                >
                  {{ item.is_active == 1 ? "Active" : "Inactive" }}
                </v-chip>
              </td>

              <td class="text-center">
                {{ item.created_by_name || "-" }}
              </td>

              <td class="text-center">
                <div
                  class="d-flex justify-center align-center"
                  style="gap: 6px"
                >
                  <!-- EDIT -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogUpdate(item)"
                      >
                        <v-icon size="18">mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>

                  <!-- DELETE -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogDelete(item)"
                      >
                        <v-icon size="18">mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Hapus</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>

    <!-- CREATE -->
    <v-dialog v-model="isDialogOpenCreate" max-width="750px">
      <v-card>
        <v-card-title class="py-4 px-6 primary white--text">
          <v-icon left color="white">mdi-plus-circle-outline</v-icon>
          Tambah Data
        </v-card-title>

        <v-card-text class="pt-5 px-6">
          <v-form v-model="isFormValidCreate">
            <v-row>
              <!-- Account -->
              <v-col cols="12">
                <v-autocomplete
                  v-model="account"
                  :items="listCoa"
                  :item-text="(item) => `${item.account} - ${item.description}`"
                  item-value="account"
                  label="Account"
                  placeholder="Pilih Account"
                  outlined
                  dense
                  clearable
                  prepend-inner-icon="mdi-magnify"
                  :rules="[(v) => !!v || 'Account wajib dipilih']"
                />
              </v-col>

              <!-- BAGIAN -->
              <v-col cols="12">
                <v-select
                  v-model="part"
                  :items="listPart"
                  label="Bagian"
                  placeholder="Pilih Bagian"
                  outlined
                  dense
                  prepend-inner-icon="mdi-shape-outline"
                  :rules="[(v) => !!v || 'Bagian wajib dipilih']"
                />
              </v-col>

              <!-- KENAIKAN HARGA -->
              <v-col cols="12">
                <v-text-field
                  v-model="kenaikan_harga"
                  label="Kenaikan Harga (%)"
                  type="number"
                  placeholder="0"
                  outlined
                  dense
                  prepend-inner-icon="mdi-cash-plus"
                  :rules="[(v) => !!v || 'Kenaikan harga wajib diisi']"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions class="px-6 py-3">
          <v-spacer />
          <v-btn text color="grey darken-1" @click="isDialogOpenCreate = false">
            <v-icon left>mdi-close</v-icon> Batal
          </v-btn>
          <v-btn
            color="primary"
            :disabled="!isFormValidCreate"
            @click="submitCreate"
          >
            <v-icon left>mdi-content-save-outline</v-icon> Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- UPDATE -->
    <v-dialog v-model="isDialogOpenEdit" max-width="520px">
      <v-card>
        <v-card-title class="py-4 px-6 warning white--text">
          <v-icon left color="white">mdi-pencil-outline</v-icon>
          Ubah Data
        </v-card-title>

        <v-card-text class="pt-5 px-6">
          <v-form v-model="isFormValidUpdate">
            <v-row>
              <!-- Account -->
              <v-col cols="12">
                <v-autocomplete
                  v-model="account"
                  :items="listCoa"
                  :item-text="(item) => `${item.account} - ${item.description}`"
                  item-value="account"
                  label="Account"
                  placeholder="Pilih Account"
                  outlined
                  dense
                  clearable
                  prepend-inner-icon="mdi-magnify"
                  :rules="[(v) => !!v || 'Account wajib dipilih']"
                />
              </v-col>

              <!-- BAGIAN -->
              <v-col cols="12">
                <v-select
                  v-model="part"
                  :items="listPart"
                  label="Bagian"
                  placeholder="Pilih Bagian"
                  outlined
                  dense
                  prepend-inner-icon="mdi-shape-outline"
                  :rules="[(v) => !!v || 'Bagian wajib dipilih']"
                />
              </v-col>

              <!-- KENAIKAN HARGA -->
              <v-col cols="12">
                <v-text-field
                  v-model="kenaikan_harga"
                  label="Kenaikan Harga (%)"
                  type="number"
                  placeholder="0"
                  outlined
                  dense
                  prepend-inner-icon="mdi-cash-plus"
                  :rules="[(v) => !!v || 'Kenaikan harga wajib diisi']"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions class="px-6 py-3">
          <v-spacer />
          <v-btn text color="grey darken-1" @click="isDialogOpenEdit = false">
            <v-icon left>mdi-close</v-icon> Batal
          </v-btn>
          <v-btn
            color="warning"
            dark
            :disabled="!isFormValidUpdate"
            @click="submitUpdate"
          >
            <v-icon left>mdi-content-save-edit-outline</v-icon> Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DELETE -->
    <v-dialog v-model="isDialogOpenDelete" max-width="420px">
      <v-card>
        <v-card-title class="py-4 px-6 error white--text">
          <v-icon left color="white">mdi-alert-circle-outline</v-icon>
          Konfirmasi Hapus
        </v-card-title>

        <v-card-text class="pt-5 px-6">
          <div class="d-flex align-center">
            <v-icon color="error" size="40" class="mr-3"
              >mdi-trash-can-outline</v-icon
            >
            <span>
              Yakin ingin menghapus data
              <b>{{ account }} - {{ name }}</b
              >?
              <br />
              <span class="caption grey--text"
                >Tindakan ini tidak dapat dibatalkan.</span
              >
            </span>
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions class="px-6 py-3">
          <v-spacer />
          <v-btn text color="grey darken-1" @click="isDialogOpenDelete = false">
            <v-icon left>mdi-close</v-icon> Batal
          </v-btn>
          <v-btn color="error" dark @click="submitDelete">
            <v-icon left>mdi-delete-outline</v-icon> Hapus
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      tabItems: ["Kertas Kerja Budget"],
      isLoading: false,
      search: "",
      tab: 1,
      tableHeaders: [
        { text: "Nama", align: "center", value: "name" },
        { text: "Account", align: "center", value: "account" },
        // { text: "Bagian", align: "center", value: "part" },
        {
          text: "Kenaikan Harga (%)",
          align: "center",
          value: "kenaikan_harga",
        },
        {
          text: "Bagian",
          align: "center",
          value: "part",
        },
        { text: "Status", align: "center", value: "status" },
        {
          text: "Dibuat Oleh",
          align: "center",
          value: "created_by_name",
        },
        { text: "Aksi", align: "center" },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: true,
        search: "",
      },
      total: null,
      list: [],
      listCoa: [],
      listPart: ["PENJUALAN", "UMUM"],
      isDialogOpenEdit: false,
      isDialogOpenDelete: false,
      isFormValidUpdate: false,
      isDialogOpenCreate: false,
      isFormValidCreate: false,
      selectedItem: null,
      id: null,
      name: null,
      account: null,
      part: null,
      noted: null,
      kenaikan_harga: null,
    };
  },
  methods: {
    fetch() {
      store.dispatch("showLoading");
      const query = this.$route.query;
      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "name",
        sortDesc: query.sortDesc || this.pagination.sortDesc || false,
        startDate: query.startDate || this.startDate,
        endDate: query.endDate || this.endDate,
      };

      api
        .get("/wb", { params })
        .then(({ data }) => {
          this.list = data.data.data;
          this.total = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching parameters:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async fetchCoa(item = null) {
      api
        .get("/coa", { search: item?.searchCoa })
        .then(({ data }) => {
          const raw = data.data.data;

          // Unik berdasarkan account, ambil account & name
          const seen = new Set();
          this.listCoa = raw
            .filter((item) => {
              if (seen.has(item.account)) return false;
              seen.add(item.account);
              return true;
            })
            .map((item) => ({
              account: item.account,
              description: item.description,
            }));

          // console.log(this.listCoa);
        })
        .catch((error) => {
          console.error("Error fetching Coa:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    openDialogCreate() {
      // reset semua field form
      this.name = null;
      this.account = null;
      this.part = null;
      this.kenaikan_harga = null;
      this.part = null;

      // reset validasi form (biar tombol disable lagi)
      this.isFormValidCreate = false;

      // buka dialog
      this.isDialogOpenCreate = true;
    },
    openDialogUpdate(params = null) {
      this.selectedItem = params;
      this.id = params.id;
      this.name = params.name;
      this.account = params.account;
      this.kenaikan_harga = params.kenaikan_harga;
      this.part = params.part;
      this.isDialogOpenEdit = true;
    },
    openDialogDelete(params = null) {
      this.selectedItem = params;
      this.id = params.id;
      this.name = params.name;
      this.isDialogOpenDelete = true;
    },
    submitCreate() {
      store.dispatch("showLoading");

      // Ambil account_combination dari listCoa berdasarkan account yang dipilih
      const selectedCoa = this.listCoa.find(
        (item) => item.account === this.account,
      );

      const payload = {
        account: this.account,
        name: selectedCoa?.description || "",
        kenaikan_harga: this.kenaikan_harga,
        part: this.part,
      };
      api
        .post("/wb", payload) // ⚠️ sesuaikan endpoint backend kamu
        .then((response) => {
          const message = response.data.message;

          this.fetch(); // refresh table
          this.isDialogOpenCreate = false;

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: true,
          });
        })
        .catch((error) => {
          let message = "Gagal menambahkan data!";

          if (error.response) {
            message = error.response.data.error || message;
          } else {
            message = error.message || message;
          }

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    submitUpdate() {
      store.dispatch("showLoading");

      // Ambil account_combination dari listCoa berdasarkan account yang dipilih
      const selectedCoa = this.listCoa.find(
        (item) => item.account === this.account,
      );

      const payload = {
        id: this.id,
        account: this.account,
        part: this.part,
        name: selectedCoa?.description || "",
        kenaikan_harga: this.kenaikan_harga,
      };
      api
        .post("/wb/update", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetch();
          this.isDialogOpenEdit = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.error || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    submitDelete() {
      store.dispatch("showLoading");

      api
        .post("/wb/delete", {
          id: this.id,
        }) // ⚠️ sesuaikan endpoint backend
        .then((response) => {
          const message = response.data.message;

          this.fetch();
          this.isDialogOpenDelete = false;

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: true,
          });
        })
        .catch((error) => {
          let message = "Gagal menghapus data!";

          if (error.response) {
            message = error.response.data.message || message;
          } else {
            message = error.message || message;
          }

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },

    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    updatePagination(query) {
      // console.log(query);
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.selectedDivisionId = parseInt(query.divisionId) || 0;
      this.selectedPositionId = parseInt(query.positionId) || 0;
      this.selectedSiteId = parseInt(query.siteId) || 0;
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
  },
  mounted() {
    store.commit("setTitle", "Kertas Kerja Budget");
    this.fetchCoa();
    this.updatePagination(this.$route.query);
  },
  watch: {
    pagination: {
      handler: "fetch",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
  },
};
</script>

<style scoped>
.v-data-table td:nth-child(2),
td:nth-child(4),
td:nth-child(5) {
  text-align: center;
}
</style>
